import axios from 'axios';

/**
 * @param {string} url
 * @return {string}
 */
export const apiUrl = (url) => {
  // локальный бэкенд pdfmt-rest подключается переменной NEXT_PUBLIC_API_URL
  // (например http://localhost:8001) — см. README, раздел «pdfmt бэкэнд».
  // Проверка идёт до location.hostname, чтобы работать и на сервере.
  if (process.env.NEXT_PUBLIC_API_URL) {
    return `${process.env.NEXT_PUBLIC_API_URL}${url}`;
  }

  const isTestEnvironment = /^test\d*\.pdfedit\.pro|localhost$/.test(location.hostname);
  const isUseTestServer = true; // if required during development, send to prod
  const apiEndpoint = isTestEnvironment && isUseTestServer
    ? 'https://test.pdfedit.pro'
    : 'https://pdfedit.pro';

  return `${apiEndpoint}${url}`;
};

/**
 * @param {string} method
 * @param {string} url
 * @param {Object} data
 * @return {AxiosPromise}
 */
const apiRequest = ({ method, url, data }) => {
  return axios({
    method,
    url: apiUrl(url),
    data,
  });
};

export default apiRequest;
